module.exports = __webpack_public_path__ + "img/if_9.ab018d07.png";